<div
  class="container-fluid justify-content-center mb-1 pt-1 pb-0 shadow-lg col-12"
>
  <div class="jumbotron-fluid mx-0 px-0 my-0 py-0">
    <div class="container my-2 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Micro Loan
          </h3>
        </div>
      </div>
    </div>
    <div class="container mx-auto px-auto mb-0 pb-1">
      <div class="d-flex mt-1 mb-0 pt-1 pb-0 mx-auto px-4 px-sm-0">
        <div class="col-12 mx-4 mx-sm-1 px-4 px-sm-0">
          <a routerLink="getloan" class="text-info"
            ><button class="btn btn-info col-4 col-md-2 mx-1 px-0">
              Get Loan
            </button>
          </a>
          <a routerLink="confirm"
            ><button class="btn btn-info col-4 col-md-2 mx-1 px-0">
              Confirm Loan
            </button>
          </a>
          <a routerLink="payloan"
            ><button class="btn btn-info col-4 col-md-2 mx-1 px-0">
              Pay Loan
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
